import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import FormField from '../form/FormField';

const UserBusinessTypeField = props => {

  let {
    businessTypes,
    onBlur,
    onChange,
    field,
    readOnly,
  } = props;

  const _onBlur = (fieldName, value) => {
    if (onBlur) {
      onBlur(fieldName, value);
    }
  };

  const _onChange = (fieldName, value) => {
    if (onChange) {
      onChange(fieldName, value);
    }
  };

  const getOptions = (_businessTypes) => {
    return _businessTypes.map(businessType => {
      return [businessType.name, businessType.label];
    })
  };

  return (
    <FormField
      {...field}
      fieldName={'businessType'}
      options={getOptions(businessTypes)}
      readOnly={readOnly}
      controlType={'select'}
      onBlur={_onBlur}
      onChange={_onChange}  />
  )

};

UserBusinessTypeField.fragments = {
  businessTypes: gql`
      fragment UserBusinessTypeField_businessTypes on BusinessType {
          id
          plainId
          name
          label
      }
  `
};

UserBusinessTypeField.propTypes = {
  businessTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  readOnly: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};

export default UserBusinessTypeField;
